import json2md from "json2md";
import React from "react";
import ReactMarkdown from "react-markdown";
import { MarkdownWrapper } from "./markdownStyled";

interface Props {
  text: string;
}

export const JsonToMarkdown = ({ text }: Props): React.ReactElement => {
  const parsedString = JSON.parse(text);

  return (
    <MarkdownWrapper>
      <ReactMarkdown>{json2md(parsedString)}</ReactMarkdown>
    </MarkdownWrapper>
  );
};
